// @flow strict

import { type Obj } from '@mondough/public-web-components'
import { type ContentfulNode } from './richTextGetters'

type ContentfulRenderer<Result> = (node: ContentfulNode) => Result

// This is the type for the mandatory renderers a theme needs to have to be fully registered
// This list does NOT include the bespoke component because that renderer doesn't change with themes
// The Keys should match the enum below
export type SectionRendererMap<Output> = {|
  cmsSectionHero: ContentfulRenderer<Output>,
  cmsSectionTextImage: ContentfulRenderer<Output>,
  cmsSectionCallToAction: ContentfulRenderer<Output>,
  cmsSectionTriptych: ContentfulRenderer<Output>,
  cmsSectionMarkdown: ContentfulRenderer<Output>,
  cmsSectionEmailSignupForm: ContentfulRenderer<Output>,
  cmsSectionBlogRoll: ContentfulRenderer<Output>,
  cmsBanner: ContentfulRenderer<Output>,
  cmsDisclosureGroup: ContentfulRenderer<Output>,
|}

// These are all the Contentful names for sections in the CMS
type CMSSectionsEnum =
  | 'cmsSectionHero'
  | 'cmsSectionTextImage'
  | 'cmsSectionCallToAction'
  | 'cmsSectionTriptych'
  | 'cmsSectionMarkdown'
  | 'cmsSectionEmailSignupForm'
  | 'cmsSectionSubtitle'
  | 'cmsSectionBespoke'
  | 'cmsSectionBlogRoll'
  | 'cmsBanner'
  | 'cmsDisclosureGroup'

export const CMSSections: Obj<string, CMSSectionsEnum> = {
  HERO: 'cmsSectionHero',
  TEXT_IMAGE: 'cmsSectionTextImage',
  SUBTITLE: 'cmsSectionSubtitle',
  CTA: 'cmsSectionCallToAction',
  TRIPTYCH: 'cmsSectionTriptych',
  MARKDOWN: 'cmsSectionMarkdown',
  BESPOKE: 'cmsSectionBespoke',
  EMAILSIGNUP: 'cmsSectionEmailSignupForm',
  BLOG_ROLL: 'cmsSectionBlogRoll',
  BANNER: 'cmsBanner',
  DISCLOSURE_GROUP: 'cmsDisclosureGroup',
}
